// extracted by mini-css-extract-plugin
module.exports = {"nav":"_3sAni","menu":"_1G1Xl","open":"_2_tg_","header":"_37MrY","active":"_3JMPx","navLink":"_1hWpu","dropDown":"bh8ja"};